module.exports = __webpack_public_path__ + "static/media/booking-menu.9b7fd395.svg";